var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupervisedSigning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#AAF08C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3655 37.1622C44.3655 37.1622 41.7262 35.4768 37.6441 39.7441C33.562 44.0115 37.433 44.1908 37.433 44.1908L47.2863 39.8159L44.3655 37.1622Z",
    fill: "white",
    stroke: "#090927",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4641 36.445L44.4377 41.6806L40.25 41.3937L44.5432 36.0506C44.5432 36.0506 46.0212 34.5803 47.4641 36.445Z",
    fill: "white",
    stroke: "#090927",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3548 40.2103C40.8475 40.4255 42.2199 40.4255 42.2199 40.4255C42.2199 40.4255 45.0351 39.1345 47.4985 37.8436C49.9266 36.5526 51.1231 38.8476 51.1231 38.8476L43.5571 44.2625C43.5571 44.2625 39.2639 45.9479 37.6099 46.6292C35.956 47.3106 34.302 46.8444 34.302 46.8444C34.302 46.8444 25.8211 44.7645 24.7302 44.4776C23.6393 44.1908 21 44.2625 21 44.2625V37.2339C21 37.2339 23.2522 35.441 25.2932 35.0465C25.2932 35.0465 28.2141 34.5445 31.0645 36.8395C31.0645 36.8395 38.2785 38.9194 39.2639 39.2062C39.2639 39.2062 41.3049 40.6765 40.0381 42.4695L30.4663 40.7841",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3548 40.2103C40.8475 40.4255 42.2199 40.4255 42.2199 40.4255C42.2199 40.4255 45.0351 39.1345 47.4985 37.8436C49.9266 36.5526 51.1231 38.8476 51.1231 38.8476L43.5571 44.2625C43.5571 44.2625 39.2639 45.9479 37.6099 46.6292C35.956 47.3106 34.302 46.8444 34.302 46.8444C34.302 46.8444 25.8211 44.7645 24.7302 44.4776C23.6393 44.1908 21 44.2625 21 44.2625V37.2339C21 37.2339 23.2522 35.441 25.2932 35.0465C25.2932 35.0465 28.2141 34.5445 31.0645 36.8395C31.0645 36.8395 38.2785 38.9194 39.2639 39.2062C39.2639 39.2062 41.3049 40.6765 40.0381 42.4695L30.4663 40.7841",
    stroke: "#090927",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.409 15.0001C37.1275 15.0001 34.805 14.9649 33.2566 16.654C31.673 14.9649 29.3856 15.0001 29.1041 15.0001C23.0865 15.0001 22.8754 20.9121 22.8754 20.9824C22.805 28.654 32.8695 33.2991 32.975 33.3343C33.0806 33.3695 33.151 33.4047 33.2566 33.4047C33.3621 33.4047 33.4677 33.3695 33.5381 33.3343C33.6437 33.2991 43.7082 28.654 43.6378 20.9824C43.6378 20.9121 43.4266 15.0001 37.409 15.0001Z",
    fill: "#e2d1fa",
    stroke: "#090927",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 35H13V47H21V35Z",
    fill: "#e2d1fa",
    stroke: "#090927",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 44C17.5523 44 18 43.5523 18 43C18 42.4477 17.5523 42 17 42C16.4477 42 16 42.4477 16 43C16 43.5523 16.4477 44 17 44Z",
    fill: "white",
    stroke: "#090927",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisedSigning);
export default __webpack_public_path__ + "static/media/supervised-signing.6cef4160de2460939142cac61f8f1f6c.svg";
export { ForwardRef as ReactComponent };